import React, { useMemo } from 'react';
import { Table } from 'semantic-ui-react';
import { columnEnforced, columnName, hasColumn } from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import RowAddColumn from '@/components/table/RowAddColumn';
import { hasWorkspaceCondition } from '../helper';

export const useDatasetConditionsTableColumns = (datasetConditions) => useMemo(() => ([
  columnName,
  ...(hasWorkspaceCondition(datasetConditions) ? [columnEnforced] : []),
]), [datasetConditions]);

const DatasetConditionsTableColumns = ({
  addDatasetCondition,
  canEdit,
  columns = [
    columnName,
    columnEnforced,
  ],
  category,
  code,
  name,
}) => (
  <Table.Row>
    {hasColumn(columns, columnName) && <UnsortedColumn columnId={columnName} colWidth={canEdit ? 14 : 15} />}
    {hasColumn(columns, columnEnforced) && <UnsortedColumn columnId={columnEnforced} colWidth={1} />}
    {canEdit && (
      <RowAddColumn
        entity="dataset.condition"
        colWidth={1}
        onClick={() => addDatasetCondition(category, code, name)}
      />
    )}
  </Table.Row>
);

export default DatasetConditionsTableColumns;
